import { Tab as MuiTab, type TabProps as MuiTabProps } from '@mui/material';
import { useForkRef } from '@mui/material/utils';
import { type AnchorHTMLAttributes, type ForwardedRef, forwardRef, type ReactElement, type RefAttributes } from 'react';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props<Value> = WithoutStyleOverrides<Omit<MuiTabProps, 'ref' | 'value'>>
  & Pick<AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'target' | 'rel' | 'download'> & {
    value: Value;
  };

// forwardRef, not a `ref` prop: the app still runs React 18, where function components never receive `ref`.
// The cast keeps the `Value` generic, which forwardRef erases.
export const Tab = forwardRef(function Tab<Value>(props: Props<Value>, ref: ForwardedRef<HTMLElement>) {
  const elementRef = useForkRef(ref);
  return <MuiTab {...props} ref={elementRef} />;
}) as <Value>(props: Props<Value> & RefAttributes<HTMLElement>) => ReactElement;

export type { Props as TabProps };
